import React from 'react';
import { DataElementChips, DataElementText } from './DataElementChips';

/**
 * Render selectedInnerDataElement - can render as chips or comma-separated text
 */
export const SelectedInnerDataElementRenderer = ({
	selectedInnerDataElement,
	classes,
	asChips = false,
	showLabel = true
}) => {
	if (!Array.isArray(selectedInnerDataElement) || selectedInnerDataElement.length === 0) {
		return null;
	}

	if (asChips) {
		return (
			<DataElementChips
				dataElementArray={selectedInnerDataElement}
				classes={classes}
				label={showLabel ? 'selectedInnerDataElement' : undefined}
			/>
		);
	}

	return (
		<DataElementText
			dataElementArray={selectedInnerDataElement}
			classes={classes}
			label={showLabel ? 'selectedInnerDataElement' : undefined}
		/>
	);
};

